exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app{height:100%;background-color:$lightBgColor}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/app/app.styl
 ** module id = 980
 ** module chunks = 0
 **/